import { Platform } from 'react-native';

/**
 * Web-only shims for browsers we still see in production.
 * Import once, before any UI module, from app/_layout.tsx.
 */
if (Platform.OS === 'web' && typeof window !== 'undefined') {
  const w = window as unknown as { HTMLDialogElement?: unknown };
  // Safari < 15.4 has no <dialog>. @tamagui/dialog runs
  // `node instanceof HTMLDialogElement` in a layout effect, which throws a
  // ReferenceError and unmounts the whole app into the error boundary
  // (Sentry REACT-NATIVE-2Q). A stand-in constructor makes the instanceof
  // check evaluate to false so Tamagui falls back to its non-native path.
  if (typeof w.HTMLDialogElement === 'undefined') {
    w.HTMLDialogElement = function HTMLDialogElement() {};
  }
}
